import React, { MouseEventHandler } from 'react';
import Button from './index';
import css from './index.module.css';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export default function MakeButton(
  label: string,
  className?: string,
  wrapperClass?: string,
  icon?: IconDefinition,
  iconAfterWord?: boolean,
  handleClick?: MouseEventHandler<HTMLButtonElement>,
  iconAfterImg?: string
) {
  return () => {
    let combinedClasses = ``;
    const classes = wrapperClass?.split(' ');

    classes?.forEach((string) => {
      combinedClasses += css[string] + ' ';
    });
    return (
      <span className={combinedClasses}>
        <Button
          label={label}
          className={className}
          icon={icon}
          iconAfterImg={iconAfterImg}
          iconAfterWord={iconAfterWord}
          handleClick={handleClick}
        />
      </span>
    );
  };
}
